export default __webpack_public_path__ + "static/media/time-left.eac5866f.svg";